import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../assets/img/powered-by-asknicely.png'


const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  ref: "container",
  class: "container"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "powered-by-b",
  src: _imports_0,
  alt: "Powered by AskNicely"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  "data-test": "agent-say-entering"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "dot dot-1" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "dot dot-2" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "dot dot-3" }, null, -1)
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  "data-test": "agent-say-text"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["onClick", "innerHTML"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "asknicely_buttonbar_label"
}
const _hoisted_20 = { class: "label_left" }
const _hoisted_21 = { class: "label_right" }
const _hoisted_22 = {
  key: 0,
  class: "asknicely_buttonbar_label_fivestar"
}
const _hoisted_23 = { class: "label_left" }
const _hoisted_24 = { class: "label_right" }
const _hoisted_25 = ["id"]
const _hoisted_26 = {
  key: 1,
  class: "message user-message"
}
const _hoisted_27 = { class: "bubble" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 0,
  class: "validation-message"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, " ", -1)
const _hoisted_31 = {
  key: 0,
  class: "message user-message"
}
const _hoisted_32 = { class: "bubble" }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "bubble" }, "Click here to reset survey", -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 0,
  class: "network-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConversationMessage = _resolveComponent("ConversationMessage")!
  const _component_ReceiveTextField = _resolveComponent("ReceiveTextField")!
  const _component_ReviewLinkButton = _resolveComponent("ReviewLinkButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: "convo",
    onMousemoveOnce: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleMouseMove && _ctx.handleMouseMove(...args))),
    onKeydownOnce: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleKeyDown && _ctx.handleKeyDown(...args)))
  }, [
    (_ctx.trackingUrl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.trackingUrl,
          alt: ""
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (!_ctx.inApp)
      ? (_openBlock(), _createElementBlock("header", {
          key: 1,
          class: _normalizeClass(_ctx.initialised ? '' : 'splash')
        }, [
          _createElementVNode("img", {
            id: "company-logo",
            src: _ctx.getCDNUrl(_ctx.logo),
            alt: ""
          }, null, 8, _hoisted_2)
        ], 2))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      (!_ctx.nobranding)
        ? (_openBlock(), _createElementBlock("footer", _hoisted_4, [
            _createElementVNode("a", {
              id: "asknicely-logo",
              href: _ctx.referrerUrl,
              target: "_blank"
            }, _hoisted_7, 8, _hoisted_5)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsWithReplies, (item, idx) => {
        return (_openBlock(), _createElementBlock("div", { key: idx }, [
          _createVNode(_Transition, { name: "from-left" }, {
            default: _withCtx(() => [
              (
                            item.status !== 'new' &&
                            item.type === 'Say' &&
                            item.cardType !== _ctx.TYPE_REVIEW_LINK_BUTTON
                        )
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass([
                            'message',
                            'agent-message',
                            { 'current-agent-message': _ctx.shouldHighlight(idx) },
                        ])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                                'bubble',
                                { 'bubble-typing': item.status === 'entering' },
                            ])
                    }, [
                      (item.status === 'entering')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _hoisted_12))
                        : (_openBlock(), _createElementBlock("span", _hoisted_13, [
                            _createVNode(_component_ConversationMessage, {
                              "csat-labels": _ctx.csatLabels,
                              content: _ctx.getItemText(item),
                              interact: _ctx.shouldInteract(idx, true),
                              onUpdatescore: _ctx.updateScore
                            }, null, 8, ["csat-labels", "content", "interact", "onUpdatescore"])
                          ]))
                    ], 2),
                    (_ctx.shouldHighlight(idx))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "avatar",
                          src: _ctx.getCDNUrl(_ctx.avatar),
                          alt: ""
                        }, null, 8, _hoisted_14))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true)
            ], undefined, true),
            _: 2
          }, 1024),
          (
                        item.status !== 'new' && item.type === 'ReceiveOption'
                    )
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_Transition, { name: "slide-down" }, {
                  default: _withCtx(() => [
                    (
                                item.reply === undefined || item.reply == null
                            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("div", {
                            class: _normalizeClass({
                                    'option-input': true,
                                    nps: _ctx.isNps(item),
                                    fivestar: _ctx.isFivestar(item),
                                    entering: item.status === 'entering',
                                })
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOptions(item), ({
                                        value,
                                        key,
                                        badgeId,
                                        isSelected,
                                    }) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: value,
                                class: _normalizeClass({
                                        'option-item': true,
                                        'option-item-selected': isSelected,
                                    }),
                                onClick: 
                                        () =>
                                            _ctx.onOptionClicked(
                                                item,
                                                key,
                                                value,
                                                badgeId,
                                                idx
                                            )
                                    ,
                                innerHTML: _ctx.fillParams(value)
                              }, null, 10, _hoisted_17))
                            }), 128)),
                            (_ctx.isMultiSelect(item))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass([
                                        'multi-select-options-done-button',
                                        { disabled: !_ctx.hasSelectedOptions(item) },
                                    ]),
                                  onClick: () => _ctx.onMultiSelectDone(item, idx)
                                }, " Done ", 10, _hoisted_18))
                              : _createCommentVNode("", true),
                            (_ctx.isNps(item))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.labelLeft(item)), 1),
                                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.labelRight(item)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2),
                          (_ctx.isFivestar(item))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.labelLeft(item)), 1),
                                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.labelRight(item)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], undefined, true),
                  _: 2
                }, 1024),
                _createVNode(_Transition, { name: "from-right" }, {
                  default: _withCtx(() => [
                    (item.link && item.reply === 'yes')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: `calendly-frame-${idx}`,
                          class: "calendly-frame"
                        }, null, 8, _hoisted_25))
                      : (item.reply !== undefined)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.getItemText(item).trim()), 1)
                          ]))
                        : _createCommentVNode("", true)
                  ], undefined, true),
                  _: 2
                }, 1024)
              ]))
            : _createCommentVNode("", true),
          (
                        item.status !== 'new' &&
                        item.type === 'ReceiveText' &&
                        item.param !== _ctx.TYPE_REVIEW_LINK_BUTTON
                    )
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createVNode(_Transition, { name: "slide-down" }, {
                  default: _withCtx(() => [
                    (item.reply === undefined)
                      ? (_openBlock(), _createBlock(_component_ReceiveTextField, {
                          key: item.param,
                          modelValue: _ctx.replyText,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.replyText) = $event)),
                          "should-focus": !_ctx.preview,
                          "border-class": _ctx.textareaBorderClass,
                          onSubmitReplyText: ($event: any) => (_ctx.receiveTextInput(item))
                        }, null, 8, ["modelValue", "should-focus", "border-class", "onSubmitReplyText"]))
                      : _createCommentVNode("", true)
                  ], undefined, true),
                  _: 2
                }, 1024),
                (_ctx.contactLookupInvalid(item))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.validationMessage), 1),
                      _hoisted_30
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_Transition, { name: "from-right" }, {
                  default: _withCtx(() => [
                    (item.reply)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.getItemText(item).trim()), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], undefined, true),
                  _: 2
                }, 1024)
              ]))
            : _createCommentVNode("", true),
          (item.param === _ctx.TYPE_REVIEW_LINK_BUTTON)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createVNode(_component_ReviewLinkButton, {
                  item: item,
                  comment: _ctx.commentForReviewLink,
                  slug: _ctx.slug,
                  onLoad: _ctx.next
                }, null, 8, ["item", "comment", "slug", "onLoad"])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.showFinishedReloadWarning && _ctx.surveyLinkConfig.slug)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("div", {
                  class: "message app-message",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.returnToSurveyLink && _ctx.returnToSurveyLink(...args)))
                }, _hoisted_36)
              ]))
            : _createCommentVNode("", true)
        ], undefined, true),
        _: 1
      })
    ], 512), [
      [_vShow, _ctx.initialised]
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showNetError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, "·"))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    })
  ], 32))
}